import { render, staticRenderFns } from "./VuesticFileUploadListItem.vue?vue&type=template&id=b6b989e8"
import script from "./VuesticFileUploadListItem.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadListItem.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadListItem.vue?vue&type=style&index=0&id=b6b989e8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b989e8')) {
      api.createRecord('b6b989e8', component.options)
    } else {
      api.reload('b6b989e8', component.options)
    }
    module.hot.accept("./VuesticFileUploadListItem.vue?vue&type=template&id=b6b989e8", function () {
      api.rerender('b6b989e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUploadListItem.vue"
export default component.exports